/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Bright_Fox_JumpInputs */

const en_calm_bright_fox_jump = /** @type {(inputs: Calm_Bright_Fox_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const de_calm_bright_fox_jump = /** @type {(inputs: Calm_Bright_Fox_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Calm_Bright_Fox_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_bright_fox_jump = /** @type {((inputs?: Calm_Bright_Fox_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Bright_Fox_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_bright_fox_jump(inputs)
	return de_calm_bright_fox_jump(inputs)
});